export const PAYMENT_TYPE = {
    CASH: {label: "Espèce", value: "CASH"},
    CHECK: {label: "Chèque", value: "CHECK"},
    TRANSFER: {label: "Virement", value: "TRANSFER"}
}